import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    buildAuthLoginHref,
    getLoginIdFromUrl,
    redirectToPortal,
} from '@/core/configs/auth/auth.config';
import { env } from '@/environments';

export default function IndexRedirect() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const id = searchParams.get('id')?.trim() || getLoginIdFromUrl();
        if (id) {
            navigate(buildAuthLoginHref(id), { replace: true });
            return;
        }

        if (env.authLocalEnabled === true) {
            navigate('/auth/login', { replace: true });
            return;
        }

        redirectToPortal('Acesso direto sem id — abra o sistema pelo portal ICMS.');
    }, [navigate, searchParams]);

    return null;
}
